import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { axiosOpen } from "../../api/axios";
import { toast, Toaster } from "react-hot-toast";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { token, id } = useParams();
  
  const handleResetPassword =(e) => async () => {
    // e.preventDefault();
   console.log(id ,token)
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
   
    const body = JSON.stringify({
      userId : id,
      token,
      password
    })
   
  const response = await axiosOpen.patch("/api/user/resetPassword",body)
    toast.success("Password reset successfully");
    setError("");
    setTimeout(() => {
      navigate('/login');
    }, 3000);
    
  }

  // const handleResetPassword = (e) => {
  //   e.preventDefault();
  //   if (password !== confirmPassword) {
  //     setError("Passwords do not match");
  //     return;
  //   }
  //   const body = {
  //     userid : id,
  //     token,
  //     password
  //   }

  //     axiosOpen.patch("/api/user/resetPassword",body)
  //    .then((res) => {
  //       console.log(res)
  //       // navigate("/login");
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     });
   
   
  //   setError("");
  // };

  return (

    <div className="reset-password-page">
      <Toaster />
      <div className="reset-password-container">
        <h1 className="text-center mb-4 text-white">New Password</h1>
        <Form className="form" onSubmit={handleResetPassword}>
          <Form.Floating>
            <Form.Control
              className="mb-3"
              id="floatingPasswordCustom"
              type="password"
              placeholder="Password"
              autoComplete="off"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              required
            />
            <label htmlFor="floatingPasswordCustom">Password</label>
          </Form.Floating>
          <Form.Floating>
            <Form.Control
              className="mb-3"
              id="floatingPasswordCustom"
              type="password"
              placeholder="Password"
              autoComplete="off"
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}
              required
            />
            <label htmlFor="floatingPasswordCustom">Confirm Password</label>
          </Form.Floating>
          {error && <div className="text-danger mb-3 text-center">{error}</div>}
          <Button  variant="primary" className="text-decoration-none text-white w-100 mb-3" 
          onClick={handleResetPassword()}>
            Reset Password
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
